import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatest, map, Observable, take } from 'rxjs';
import { ProductFacade } from '../../product/facade/product.facade';
import { RoutingService } from '@boels/helpers';
import { CmsFacade } from '../../cms/facade/cms.facade';
import { MetaDataModel, Page } from '@boels/models';

export const ProductMetaDataResolver: ResolveFn<{
  routeResolver: Page | undefined;
  metaData: MetaDataModel;
}> = (route: ActivatedRouteSnapshot) => {
  return resolve(route);
};

const resolve = (
  route: ActivatedRouteSnapshot,
): Observable<{
  routeResolver: Page | undefined;
  metaData: MetaDataModel;
}> => {
  const productFacade = inject(ProductFacade);
  const translocoService = inject(TranslocoService);
  const routingService = inject(RoutingService);
  const cmsFacadeService = inject(CmsFacade);

  return combineLatest([
    cmsFacadeService.activeLoaded$,
    productFacade.get(route.params['productCode']),
    translocoService.selectTranslate(
      'storeDetails.metaDescription',
      {},
      { scope: 'storeFinder' },
    ),
  ]).pipe(
    map(([page, product, metaDescriptionTranslated]) => {
      const resolvedData = {
        routeResolver: page,
        metaData: {
          metaTitle:
            product?.metaTitle ||
            (product?.name ? product?.name + ' | Boels' : ''),
          metaDescription:
            product?.metaDescription || metaDescriptionTranslated,
        },
      };

      route.data = {
        ...route.data,
        resolvedData: resolvedData,
      };
      routingService.setActivatedRouteSnapshot(route);

      return resolvedData;
    }),
    take(1),
  );
};
